import React from "react";
import { createPortal } from "react-dom";

type Props = {
  children: React.ReactNode;
  targetId?: string;
};

export function Portal(props: Props) {
  const { children, targetId } = props;
  const [mounted, setMounted] = React.useState(false);

  React.useEffect(() => {
    setMounted(true);

    return () => setMounted(false);
  }, []);

  if (!mounted) {
    return null;
  }

  return createPortal(children, targetId ? (document.getElementById(targetId) as HTMLElement) : document.body);
}
